import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Malishevskaya from "../../../../images/staff/Malishevskaya N.P..jpg";
import Accordion from "../../../Accordion/Accordion.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

import data from "../../../Data/scientificEducational/scientificEducationalData.json";

export default function ScientificEducational() {
  useSEO(seoConfig.scientificEducational);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Научно - образовательный отдел
      </h1>

      <h3 className="about-nii__title antiCorruption__title">
        Образовательная деятельность входит в один из основных видов
        деятельности ГБУ СО "УрНИИДВиИ" и возложена на научно-образовательный
        отдел.
      </h3>

      <h3 className="about-nii__title antiCorruption__title">
        Заведующий научно-образовательным отделом УрНИИДВиИ, доктор медицинских
        наук, профессор Малишевская Нина Петровна
      </h3>

      <img
        alt="Малишевская Н.П."
        className="scientificeducational__image"
        src={Malishevskaya}
      ></img>

      <div className="scientificeducational__link">
        <Accordion data={data} />
      </div>

      <p className="dissertation__text">Контакты:</p>
      <div className="additional__links">
        <a
          href="tel:+73432107717"
          className="dissertation__text additional__tel"
        >
          +7 (343) 210-77-17
        </a>
        <div className="additional__links-two">
          {/* <p className="dissertation__text">E-mail: </p> */}
          <a
            href="mailto:orgotdel_2008@mail.ru"
            className="dissertation__text contacts__table-tel additional__tel"
          >
            orgotdel_2008@mail.ru
          </a>
        </div>
      </div>

      <p className="dissertation__text">
        Заведующий научно-образовательным отделом профессор, д.м.н. Малишевская
        Нина Петровна
      </p>

      <div className="additional__links">
        <a
          href="tel:+73432189585"
          className="dissertation__text additional__tel"
        >
          +7 (343) 218-95-85
        </a>
        {/* <div className="additional__links-two">
          <p className="dissertation__text">E-mail: </p>
          <a
            href="mailto:urniidvii@bk.ru"
            className="dissertation__text contacts__table-tel additional__tel"
          >
            urniidvii@bk.ru
          </a>
        </div> */}
      </div>

      <p className="dissertation__text">
        Начальник отдела кадров: Петрунина Людмила Степановна
      </p>
    </section>
  );
}
